import ReactDOM from 'react-dom/client'
import './index.css'
import {App} from './App'

const rootElement = document.getElementById('root')

if (!rootElement) {
  throw new Error("Root container missing in index.html")
}

ReactDOM.createRoot(rootElement).render(
  <App />
)
